<template>
<b-container fluid>
  <br>
  <h1>Register</h1>
  <b-row class="justify-content-md-center">
    <b-col lg="4" sm="8" md="6">
      <b-form v-on:submit.prevent="validateEntry">
          <b-form-group
      id="fieldset-1"
      label="Email"
      label-align="left"
      label-for="email-id"
    >

    <b-form-input id="email-id" v-model="email" type="email" :state="newEmail" aria-describedby="email-help-block"></b-form-input>
          </b-form-group>

  <b-form-invalid-feedback :state="newEmail"
      id="email-help-block">Email already exists, please login instead.</b-form-invalid-feedback>

    <b-form-group
    id="fieldset-2"
    label="Password"
    label-align="left"
    label-for="password-id"

  >
    <b-form-input class="mb-4" id="password-id" v-model="password" type="password" :state="strongPassword" aria-describedby="password-help-block"></b-form-input>
    </b-form-group>
    <b-form-invalid-feedback :state="strongPassword" id="password-help-block">Passwords must have 8 characters and include uppercase characters.</b-form-invalid-feedback>
    <b-form-checkbox
      id="checkbox-1"
      class="mb-3"
      v-model="termsAccepted"
      name="terms-checkbox"
      size="lg"
      :state="validateTerms"
      aria-describedby="terms-help-block"
    >I accept the <router-link :to="{name:'terms'}">terms of use</router-link></b-form-checkbox>
        <b-form-invalid-feedback :state="validateTerms" id="terms-help-block">Please accept our terms to use this service.</b-form-invalid-feedback>
   <b-button class="mt-3" id="submit-id" type="submit" block variant="outline-primary">Submit</b-button>
      </b-form>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: '',
            newEmail: null,
            strongPassword: null,
            termsAccepted: false,
            validateTerms: null,
        }
    },
    methods: {

        validateEntry(){

            var contains_uppercase = /[A-Z]/.test(this.password)
            var password_length = this.password.length >= 8

            if(contains_uppercase && password_length && this.termsAccepted) {
                this.registerUser()
            }
            else if(!this.termsAccepted) {
                    this.validateTerms = false;
                }
            else {
                this.strongPassword = false;
            }
        },
        registerUser() { // call loginUSer action
            var vouchercode = this.$route.query.voucher || ''
            this.$store.dispatch('registerUser', {
                email: this.email.toLowerCase(),
                password: this.password,
                vouchercode: vouchercode
            })
                .then(() => {
                    this.newEmail = true
                    this.$gtag.event('registration', { method: 'Registration' })
                    this.$router.push('/profile')
                    this.$parent.showAlert("activationsent")
                })
                .catch(err => {
                    console.log(err)
                    this.newEmail = false
                })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Register.vue